import Vue from 'vue'

const currency = (value = 0) => {
  const val = (value / 1).toFixed(0).replace('.', ',')
  return '¥ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

Vue.filter('currency', currency)
